import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { buildMediaCountsPath, PhotoflipperModel } from 'client/data/models/photoflipper';
import { StyledSelect } from 'site-modules/shared/components/styled-select/styled-select';
import { TabsPanel } from 'client/site-modules/shared/components/tabs-panel/tabs-panel';

function CategorySelectorUI({ photosCounts, params, search, selectedCategory, setCategory, isMobile }) {
  const handleSelectChange = useCallback(
    option => {
      setCategory(get(option, 'value', ''));
    },
    [setCategory]
  );

  if (!photosCounts) {
    return null;
  }

  const { make, model, year } = params;
  const { all = 0, exterior = 0, interior = 0, colors = 0 } = photosCounts;
  const basePathname = `/${make}/${model}/${year}/pictures/`;
  const categories = [
    {
      value: 'all',
      label: `All (${all})`,
      link: `${basePathname}${search}`,
    },
    {
      value: 'exterior',
      label: `Exterior (${exterior})`,
      link: `${basePathname}exterior/${search}`,
    },
    {
      value: 'interior',
      label: `Interior (${interior})`,
      link: `${basePathname}interior/${search}`,
    },
    {
      value: 'colors',
      label: `Colors (${colors})`,
      link: `${basePathname}colors/${search}`,
    },
  ];

  return isMobile ? (
    <StyledSelect
      value={selectedCategory}
      options={categories}
      onChange={handleSelectChange}
      labelText="View"
      labelClassName="fw-bold size-16 text-gray-darker"
      id="pictures-select-category"
      className="category-select"
      name="category-select"
      wrapperClassName="col-xs-12 col-md-6 px-0 mb-md-1"
    />
  ) : (
    <TabsPanel
      options={categories}
      selectedOption={selectedCategory}
      className="category-select d-block border-bottom"
      tabClassName="px-0 py-0_5 me-1"
    />
  );
}

CategorySelectorUI.propTypes = {
  photosCounts: PropTypes.shape({
    all: PropTypes.number,
    interior: PropTypes.number,
    exterior: PropTypes.number,
    colors: PropTypes.number,
  }),
  params: PropTypes.shape({
    make: PropTypes.string,
    model: PropTypes.string,
    year: PropTypes.string,
  }),
  selectedCategory: PropTypes.string.isRequired,
  setCategory: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  search: PropTypes.string,
};

CategorySelectorUI.defaultProps = {
  params: {},
  photosCounts: null,
  isMobile: false,
  search: '',
};

export const propsAreEqual = (prevProps, { photosCounts }) => !photosCounts;
export const CategorySelector = connectToModel(React.memo(CategorySelectorUI, propsAreEqual), {
  photosCounts: bindToPath(({ params }) => buildMediaCountsPath(params), PhotoflipperModel),
});
